import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Routes.css';
import logo from '../assets/logo.png';

function Routes() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [showNav, setShowNav] = useState(true);
    const lastY = useRef(0);
    const threshold = useRef(0);

    const toggleMenu = () => setMenuOpen((open) => !open);
    const closeMenu = () => setMenuOpen(false);

    useEffect(() => {
        const computeThreshold = () => {
            const home = document.getElementById('home');
            const base = home ? home.offsetHeight : window.innerHeight;
            threshold.current = Math.max(140, base - 120);
        };

        const handleScroll = () => {
            const current = window.scrollY;
            setScrolled(current > 10);

            if (menuOpen) {
                setShowNav(true);
                lastY.current = current;
                return;
            }

            if (current <= threshold.current) {
                setShowNav(true);
                lastY.current = current;
                return;
            }

            if (current > lastY.current + 2) {
                setShowNav(false);
            } else if (current < lastY.current - 2) {
                setShowNav(true);
            }

            lastY.current = current;
        };

        computeThreshold();
        lastY.current = window.scrollY;
        setShowNav(true);
        setScrolled(window.scrollY > 10);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', computeThreshold);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', computeThreshold);
        };
    }, [menuOpen]);

    return (
        <>
            <nav className={`app-routes ${scrolled ? 'scrolled' : ''} ${showNav ? '' : 'hidden'}`}>
                <Link to="/" id="logo" onClick={closeMenu}>
                    <img src={logo} alt="RiktigtRent logo" className="logo" />
                </Link>

                <button
                    className={`hamburger ${menuOpen ? 'open' : ''}`}
                    onClick={toggleMenu}
                    aria-label="Toggle navigation menu"
                >
                    <span className="hamburger-line" />
                    <span className="hamburger-line" />
                    <span className="hamburger-line" />
                </button>

                <div>
                    <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
                        <li><Link to="/" onClick={closeMenu}>Hem</Link></li>   
                        <li><Link to="/services" onClick={closeMenu}>Tjänster</Link></li>
                        <li><Link to="/calculator" onClick={closeMenu}>Kalkyl</Link></li>
                        <li><Link to="/about" onClick={closeMenu}>Om oss</Link></li>
                        <li><Link id="contact-link" to="/kontakt" onClick={closeMenu}>Kontakt</Link></li>
                    </ul>
                    <button
                        className={`close-menu ${menuOpen ? 'visible' : ''}`}
                        onClick={closeMenu}
                        aria-label="Stäng menyn"
                    >
                        ×
                    </button>
                </div>
            </nav>
            <div className="nav-spacer" aria-hidden="true" />
        </>
    );
}
export default Routes;